module.exports = __webpack_public_path__ + "img/plus-in-circle-icon.1829d971.svg";